export namespace ServiceWorkerVersion {
  export let isServiceWorker: boolean = false;
  export let version = 20;
}
